import $ from 'jquery';
import 'script-loader!../../vendor/laravel-jsvalidation/js/jsvalidation';

function validateElementAndRelated(validator, $element, onFocusOut) {
    $element.add($element.data('validateRelated')).each(function () {
        if (
            this.name in validator.submitted
            || this.name in validator.invalid
            || (onFocusOut && $element.is(this) && ! validator.optional(this))
        ) {
            validator.element(this);
        }
    });
}

function showElementValidatonState($element, toggledStates) {
    for (const state in toggledStates) {
        $element.toggleClass('is-' + state, toggledStates[state]);
    }
    $element.trigger('changeValidationState.sysVision', toggledStates);
}

$.validator.setDefaults({
    errorElement: 'div',
    errorClass: 'invalid-feedback',
    validClass: 'is-valid',

    unhighlight: null,

    showErrors: function () {
        const validator = this;

        $.each(this.errorList, function (index, error) {
            validator.showLabel(error.element, error.message);
            showElementValidatonState($(error.element), {invalid: true, valid: false});
        });

        $.each(this.successList, function (index, element) {
            validator.invalid[element.name] = false;
            showElementValidatonState($(element), {invalid: false, valid: ! validator.optional(element)});
        });
    },

    normalizer: function (value) {
        if (typeof  value !== 'string') {
            return '';
        }

        if (this.type !== 'password') {
            value = value.trim();
        }

        return value;
    },

    onfocusout: function (element) {
        if (this.checkable(element)) {
            return;
        }

        validateElementAndRelated(this, $(element), true);
    },

    onkeyup: function (element, event) {
        if ([9, 16, 17, 18, 20, 35, 36, 37, 38, 39, 40, 45, 144, 225].includes(event.keyCode)) {
            return;
        }

        validateElementAndRelated(this, $(element));
    },

    onclick: function (element) {
        let $element = $(element);
        if ($element.is('option')) {
            $element = $element.closest('select');
        }

        validateElementAndRelated(this, $element);
    },
});
